import {EnrichedPgpKey, EnrichedPgpSignature, EnrichedPgpSubKey, EnrichedPgpUser, EnrichedVerificationResult} from "../domain/pgp/EnrichedPgpKey";
import {config, SignaturePacket, User} from "openpgp";
import {PgpKey} from "../domain/PgpKey";
import {formatDateTimeAsFriendlyString} from "../util/DateHelper";
import {DateTime} from "luxon";
import {toTitleCase} from "../util/Formatters";

function enrichPgpUser(user: User): EnrichedPgpUser {
    const certifications = [];

    const hadCertifications = new Set<string>();
    for (const certification of user.selfCertifications) {
        const id = certification.issuerKeyID.toHex();
        if (!hadCertifications.has(id)) {
            certifications.push(enrichPgpSignature(certification, user));
            hadCertifications.add(id);
        }
    }

    for (const certification of user.otherCertifications) {
        const id = certification.issuerKeyID.toHex();
        if (!hadCertifications.has(id)) {
            certifications.push(enrichPgpSignature(certification, user));
            hadCertifications.add(id);
        }
    }

    return {
        user,
        userId: user.userID?.userID,
        email: user.userID?.email,
        name: user.userID?.name,
        certifications,
    };
}

function enrichPgpSignature(signature: SignaturePacket, user: User): EnrichedPgpSignature {
    return {
        signature,
        user,
        // verified: false,//signature.verified, // TODO: do we need the 'verified' flag on EnrichedPgpSignature anymore? It doesn't seem to be used
        issuerKeyId: signature.issuerKeyID,
    };
}

function expiryDateToString(date: number | Date | null): string {
    if (date !== null && typeof (date) === "object") {
        return formatDateTimeAsFriendlyString(DateTime.fromJSDate(date as Date), false);
    } else {
        return "Never";
    }
}

export async function enrichPgpKey({key}: PgpKey, allKeys: PgpKey[]): Promise<EnrichedPgpKey> {
    let verificationError = "";
    let verificationResults: EnrichedVerificationResult[] = [];
    let expiryDate: string;
    const primaryUser = enrichPgpUser(key.users[0]);
    let primaryUserString = "";
    try {
        primaryUserString = toTitleCase(primaryUser.name ?? "");
        if (primaryUser.email) {
            primaryUserString += ` <${primaryUser.email}>`;
        }
        if (!primaryUserString) {
            primaryUserString = primaryUser.userId ?? "";
        }

        verificationResults = await key.verifyAllUsers(
            allKeys.map(k => k.key), undefined, {...config, ignoreUnsupportedPackets: true});

        await key.verifyPrimaryKey();

    } catch (e: any) {
        verificationError = "" + e.message;
    }

    try {
        const date = await key.getExpirationTime();
        expiryDate = expiryDateToString(date);
    } catch (e) {
        expiryDate = "" + e;
    }

    const subKeys: EnrichedPgpSubKey[] = [];

    // for (const subKey of key.subKeys) {
    //     try {
    //         const signature = await subKey.verify(key.primaryKey);
    //         console.log(subKey);
    //         console.log(signature);
    //         subKeys.push({
    //             verified: signature.verified,
    //             signedBy: findPgpKey(signature.issuerKeyId, allKeys),
    //             signatures: subKey.bindingSignatures.map(enrichPgpSignature),
    //         });
    //     } catch (e: any) {
    //         console.log(e.message);
    //         subKeys.push({
    //             verified: false,
    //             signedBy: undefined,
    //             signatures: subKey.bindingSignatures.map(enrichPgpSignature),
    //         });
    //     }
    // }

    return {
        primaryUser,
        primaryUserString,
        fingerprint: key.getFingerprint(),
        users: key.users.map(enrichPgpUser),
        verificationError,
        subKeys,
        verificationResults,
        expiryDate,
    };
}
